export default {
  title: 'Verify your identity',
  subtitle: 'Enter the last 4 digits of the patient phone number or the order ID to view delivery details.',
  'type-phone': 'Patient phone (last 4 digits)',
  'type-order': 'Order ID (last 4 digits)',
  code: 'Last 4 digits',
  submit: 'Continue',
  'attempts-remaining': 'Attempts remaining: {count}',
  blocked: 'Too many attempts. Try again in {minutes} min.',
  'invalid-code': 'Incorrect code. Please try again.',
  expired: {
    title: 'Link expired',
    description: 'Access to this order is no longer available (14-day limit).',
  },
  forbidden: {
    title: 'Access denied',
    description: 'You do not have permission to view this page.',
  },
}
